<script lang="ts" setup>
const router = useRouter()
const isNavigating = ref(false)

useHead({
  htmlAttrs: { lang: 'en-US' },
  script: [
    {
      innerHTML: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${import.meta.env.VITE_GOOGLE_TAG_ID}');
      `,
      key: 'gtag-config',
    },
  ],
})

useScript({
  src: `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GOOGLE_TAG_ID}`,
  async: true,
})

router.beforeEach(() => {
  isNavigating.value = true
})

router.afterEach(async () => {
  await nextTick()
  isNavigating.value = false
})
</script>

<template>
  <MotionConfig
    :transition="{
      duration: isNavigating ? 0 : undefined
    }"
  >
    <RouterView />
  </MotionConfig>
</template>
